import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDataProvider, useNotify, type Identifier } from "ra-core";

import type { CrmDataProvider } from "../providers/types";

/**
 * «В сделку»: vv_convert_lead makes (or finds) the contact, the company and
 * the deal and moves the lead to the «won» stage. Lists of all four are
 * refreshed afterwards.
 */
export const useConvertLead = ({
  onConverted,
}: { onConverted?: (dealId: Identifier) => void } = {}) => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  const queryClient = useQueryClient();
  const notify = useNotify();
  return useMutation({
    mutationFn: (leadId: Identifier) => dataProvider.convertLead(leadId),
    onSuccess: ({ dealId }) => {
      for (const resource of ["leads", "deals", "contacts", "companies"]) {
        queryClient.invalidateQueries({ queryKey: [resource] });
      }
      notify("crm.leads.converted", { type: "success" });
      onConverted?.(dealId);
    },
    onError: (error: Error) => {
      notify(error?.message || "crm.leads.convert_error", { type: "error" });
    },
  });
};
